import { BetaFeatureOnly } from "@/components/beta-feature";
import { Button } from "@/toggle-ui-kit/button";
import type { ReactNode } from "react";

/** DSD 리뷰 상단 바의 베타 on/off 토글. 베타 밖에서는 렌더하지 않는다 */
export const DsdBetaToggleButton = ({
  pressed,
  onPressedChange,
  children,
}: {
  pressed: boolean;
  onPressedChange: (pressed: boolean) => void;
  children: ReactNode;
}) => (
  <BetaFeatureOnly>
    <Button
      variant={pressed ? "solid" : "outlined"}
      color="secondary"
      size={32}
      aria-pressed={pressed}
      onClick={() => onPressedChange(!pressed)}
      className={!pressed ? "bg-background-base" : undefined}
    >
      {children}
    </Button>
  </BetaFeatureOnly>
);
